import { render, staticRenderFns } from "./orderS.vue?vue&type=template&id=968abe9c&scoped=true&"
import script from "./orderS.vue?vue&type=script&lang=js&"
export * from "./orderS.vue?vue&type=script&lang=js&"
import style0 from "./orderS.vue?vue&type=style&index=0&id=968abe9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968abe9c",
  null
  
)

export default component.exports